import React, { FC } from 'react';
import { styled } from 'linaria/react';
import { baseColors, withTheme } from '@shared/lib/theme';
import { BottomSheetProps } from '@shared/ui/molecules';
import { Text } from '@shared/ui/atoms';
import { CrossIcon } from '@shared/assets/icons';
import { newAccountInstructionSteps } from '../../config/newAccountInstructionSteps';
type ModalContentProps = Pick<BottomSheetProps, 'onClose'>;
const ModalContent: FC<ModalContentProps> = ({
  onClose
}) => <>
    <HeaderWrapper>
      <Text family="MTSWide" size={{
      desktop: 'h6',
      mobile: 'pL'
    }} weight="bold" color="primary">
        Как пополнить новый аккаунт Steam?
      </Text>
      <IconButtonWrapper type="button" onClick={onClose}>
        <CrossIcon />
      </IconButtonWrapper>
    </HeaderWrapper>
    <StepsWrapper>
      {newAccountInstructionSteps.map((step, index) => <StepWrapper key={index}>
          <NumberWrapper>
            <Text family="MTSWide" size="captionL" weight="bold" color={baseColors.neutral_50}>
              {index + 1}
            </Text>
          </NumberWrapper>
          <ContentWrapper>{step.content}</ContentWrapper>
        </StepWrapper>)}
    </StepsWrapper>
  </>;
export default ModalContent;
const HeaderWrapper = /*#__PURE__*/styled('div')({
  name: "HeaderWrapper",
  class: "h1q9idmg",
  propsAsIs: false
});
const _exp = /*#__PURE__*/() => ({
  theme
}) => theme.colors.icon.tertiary;
const IconButtonWrapper = withTheme(/*#__PURE__*/styled('button')({
  name: "IconButtonWrapper",
  class: "iwpfda4",
  propsAsIs: false,
  vars: {
    "iwpfda4-0": [_exp()]
  }
}));
const StepsWrapper = /*#__PURE__*/styled('div')({
  name: "StepsWrapper",
  class: "s17omqti",
  propsAsIs: false
});
const StepWrapper = /*#__PURE__*/styled('div')({
  name: "StepWrapper",
  class: "sj487dt",
  propsAsIs: false
});
const _exp2 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.icon.accent;
const NumberWrapper = withTheme(/*#__PURE__*/styled('div')({
  name: "NumberWrapper",
  class: "n1nggxs5",
  propsAsIs: false,
  vars: {
    "n1nggxs5-0": [_exp2()]
  }
}));
const ContentWrapper = /*#__PURE__*/styled('div')({
  name: "ContentWrapper",
  class: "c1v13tf8",
  propsAsIs: false
});

require("./ModalContent.linaria.module.css!=!../../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./ModalContent.tsx");